function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentsInactive = function SvgPaymentsInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 40,
    fill: "none",
    opacity: 0.6,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M26 9v22m5-18h-7.5a3.5 3.5 0 1 0 0 7h5a3.5 3.5 0 1 1 0 7H20",
    fill: "none",
    stroke: props.fill,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default SvgPaymentsInactive;